<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="width: 600px;">
            <el-form-item v-if="menuType == 0" label="父级菜单" prop="parentId">
                <el-select v-model="form.parentId">
                    <el-option v-for="item in menus" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="菜单名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入菜单名称"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="menuType">
                <el-select v-model="form.menuType" :disabled="menuType == 1">
                    <el-option :value="0" label="目录"></el-option>
                    <el-option :value="1" label="菜单"></el-option>
                    <el-option :value="2" label="按钮"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="路由" prop="uri">
                <el-input v-model="form.uri" placeholder="请输入菜单路由"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sortNo">
                <el-input-number v-model="form.sortNo" placeholder="请输入菜单排序" style="width: 200px"></el-input-number>
            </el-form-item>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, edit, detail, list } from "@/api/permission/menu";
export default {
    data() {
        return {
            id: null,
            pid: null,
            menus: [],
            form: {
                parentId: null,
                name: "",
                menuType: "",
                uri: "",
                sortNo: 0
            },
            menuType: '',
            rules: {
                name: [{ required: true, message: '请输入菜单名称' }],
                menuType: [{ required: true, message: '请选择菜单类型' }],
                uri: [{ required: true, message: '请输入菜单路由' }],
                sortNo: [{ required: true, message: '请输入菜单排序' }],
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.pid = this.$route.query.pid;
        this.menuType = this.$route.query.menuType;
        if (this.id) {
            this.getDetail();
        }
        if (this.pid) {
            this.form.parentId = +this.pid;
            this.getList();
        }
        if (this.menuType == 1) {
            this.form.menuType = 2;
        }
    },
    methods: {
        getDetail() {
            detail({ id: this.id }).then(({ code, result }) => {
                if (code == 200) {
                    this.form = { ...result };
                }
            })
        },
        getList() {
            list().then(({ code, message, result }) => {
                if (code == 200) {
                    this.menus = result;
                } else {
                    this.$message.error(message);
                }
            })
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form
                }
                if (!this.id) {
                    add(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                } else {
                    params.id = this.id;
                    edit(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>